import { render } from "./mpesa.vue?vue&type=template&id=2093bec1&scoped=true"
import script from "./mpesa.vue?vue&type=script&lang=js"
export * from "./mpesa.vue?vue&type=script&lang=js"

import "./mpesa.vue?vue&type=style&index=0&id=2093bec1&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2093bec1"]])

export default __exports__